const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29,10.65A18.34,18.34,0,0,0,13.09,38.13l-2.37,7.34a1.46,1.46,0,0,0,.35,1.46,1.47,1.47,0,0,0,1.46.35l7.34-2.37A18.35,18.35,0,1,0,29,10.65Zm0,33.83a15.36,15.36,0,0,1-8.19-2.35,1.45,1.45,0,0,0-1.2-.15l-5.3,1.71L16,38.39a1.49,1.49,0,0,0-.15-1.2A15.48,15.48,0,1,1,29,44.48ZM30.79,29A1.79,1.79,0,1,1,29,27.21,1.79,1.79,0,0,1,30.79,29ZM38,29a1.8,1.8,0,1,1-1.79-1.79A1.79,1.79,0,0,1,38,29ZM23.63,29a1.8,1.8,0,1,1-1.8-1.79A1.8,1.8,0,0,1,23.63,29Z",
    style: {
      fill: "#30373d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.05820ee4a1f34401129880d3adc51560.svg";
export { ForwardRef as ReactComponent };